import { Component, OnInit, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Employee } from 'src/app/_model/Employee';
import { EmployeeService } from 'src/app/_services/employee.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {DialogCloseData} from '../../_model/models';
import {DIALOG_OPERATIONS} from '../../_utils/constants';

@Component({
  selector: 'app-employee-delete',
  templateUrl: './employee-delete.component.html',
  styleUrls: ['./employee-delete.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule,
    MatIconModule,
    MatTooltipModule
  ]
})
export class EmployeeDeleteComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<EmployeeDeleteComponent>,
    private employeeService: EmployeeService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Employee,
    private toastr: ToastrService) { }

  ngOnInit() {
  }
  deleteEmployee(employee: Employee) {
    this.employeeService.deleteEmployee(employee).subscribe(result => {
        this.toastr.success('Silme işlemi başarılı', '');
        this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.DELETE, employee.id));
    }, error => {
        this.toastr.error(error.error.msg, 'Hata');
        this.dialogRef.close();
    });
}
}
